import React from 'react';
import { Trans } from 'react-i18next';
import { BiLink, BiEventType } from '../../../biLogger';
import EyeDisc2 from '../../../Icons/EyeDisc2';
import PremiumFolderDisc from '../../../Icons/PremiumFolderDisc';
import { IconSize } from '../../../Icons/IconWrap';
import s from './CommentPayWall.scss';
export var CommentPayWall = function (_a) {
    var _b = _a.canUserComment, canUserComment = _b === void 0 ? true : _b, isPaidFolder = _a.isPaidFolder, children = _a.children, authorName = _a.authorName, folderId = _a.folderId, startFolderAccess = _a.startFolderAccess;
    if (canUserComment) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: s['root'] }, isPaidFolder ? (React.createElement(React.Fragment, null,
        React.createElement(PremiumFolderDisc, { size: IconSize.SMALL, className: s['icon'] }),
        React.createElement(Trans, { i18nKey: "commentbox.paywall.premiumFolders.locked", parent: "span" },
            React.createElement(BiLink, { onClick: function (e) {
                    if (folderId) {
                        startFolderAccess(folderId);
                        e.preventDefault();
                    }
                }, className: s.link, biData: {
                    evid: BiEventType.DEFAULT,
                } }, 'Unlock'),
            " the artist's premium folder to join the discussion."))) : (React.createElement(React.Fragment, null,
        React.createElement(EyeDisc2, { size: IconSize.SMALL, className: s['icon'] }),
        React.createElement(Trans, { i18nKey: "commentbox.paywall.watchersFolders.locked", parent: "span" },
            'Watch ',
            React.createElement("span", null, { authorName: authorName }),
            ' to join the discussion.')))));
};
CommentPayWall.displayName = 'CommentPayWall';
export default CommentPayWall;
//# sourceMappingURL=CommentPayWall.js.map